import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=05d0ffe9"
import script from "./emptyPage.vue?vue&type=script&lang=js"
export * from "./emptyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports